// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".adres {\n  width: 200px;\n}\n", "",{"version":3,"sources":["webpack://./src/app/objecten/afleveradressen/afleveradres-edit/afleveradres-edit.component.less"],"names":[],"mappings":"AAAA;EACE,YAAA;AACF","sourcesContent":[".adres {\n  width:200px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
